export { default as CollectionList } from './collection-list.component'
